import type { PluginRegistry } from './PluginRegistry';
import type {
  CellRendererPlugin,
  EditorPlugin,
  FormatterPlugin,
  ValidatorPlugin,
} from './types';

export function mergePluginRegistry(target: PluginRegistry, source: PluginRegistry): void {
  type Maps = {
    cellRenderers: Map<string, CellRendererPlugin>;
    editors: Map<string, EditorPlugin>;
    formatters: Map<string, FormatterPlugin>;
    validators: Map<string, ValidatorPlugin>;
  };
  const src = source as unknown as Maps;
  src.cellRenderers.forEach((p) => target.registerCellRenderer(p));
  src.editors.forEach((p) => target.registerEditor(p));
  src.formatters.forEach((p) => target.registerFormatter(p));
  src.validators.forEach((p) => target.registerValidator(p));
}
